export default __webpack_public_path__ + "static/chaos-dwarfs-62dc93a2c99fd71093931ad04d0bae86.webp";